<template>
  <div class="settle-accounts-info">
    <div class="settle-account-table">
      <vxe-grid
        border
        show-overflow
        show-footer
        :footer-method="footerMethod"
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :edit-rules="tableRules"
        :data="tableData"
        :toolbar="{}"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        @edit-closed="closeEditTableHandler"
        :edit-config="{ trigger: 'click', mode: 'cell', activeMethod: activeRowMethod }"
        height="300"
      >
        <template v-slot:buttons v-if="isCreate">
          <el-button
            @click="introductionFeeHandler"
            size="small"
            type="primary"
            class="vxe-btn-primary"
            >引入费用</el-button
          >
          <el-button
            @click="deleteBtnClickHandler"
            size="small"
            type="danger"
            class="vxe-btn-delete"
            >删除</el-button
          >
        </template>
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
          :sortable="item.sortable"
          :edit-render="item.editRender"
        >
          <template v-slot="{ row }">
            <span v-if="item.field == 'expenseType'">{{
              expenseType?.find((item) => item.value == row['expenseType'])?.label
            }}</span>
            <span v-else-if="item.field == 'currencyCode'">{{
              currencyList?.find((item) => item.value == row['currencyCode'])?.label
            }}</span>
            <span v-else-if="item.field == 'originalPrice'">{{
              row['originalPrice'].toFixed(4)
            }}</span>
            <!-- <span v-else-if="item.field === 'originalAmount'">{{
              row['originalAmount'].toFixed(2)
            }}</span> -->
            <!-- <span v-else-if="item.field == 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</span> -->
            <span v-else>{{ row[item.field] }}</span>
          </template>
          <template v-slot:edit="{ row }">
            <!-- 抵扣金额本币含税） -->
            <el-input-number
              :precision="2"
              :controls="false"
              v-if="item.editRender.name == 'deductionDomesticAmount'"
              v-model="row[item.field]"
              @input="() => handleChange(row, item.field)"
            ></el-input-number>
          </template>
        </vxe-table-column>
      </vxe-grid>
      <IntroductionCostDialog ref="IntroductionCostDialog" @confirmHandler="confirmHandler" />
      <!-- 分页 -->
      <IPagination
        :total="tableTotal"
        :multipleSelection="selectionList"
        @changePageHandler="changePageHandler"
      />
    </div>
  </div>
</template>

<script>
  import { tableColumnList, tableRules } from './index.js';
  import IntroductionCostDialog from '../IntroductionCostDialog/index.vue';
  import BASEAPI from '@/api/dataBase.js';
  export default {
    components: {
      IntroductionCostDialog,
    },
    name: 'SettleAccountsInfo',
    props: {
      tableDataList: {
        type: Array,
        default: () => [],
      },
      baseFormData: {
        type: Object,
        require: true,
      },
      isCreate: {
        type: Boolean,
        require: true,
      },
      contractCategory: {
        type: String,
        default: () => '',
      },
      currentSettleAccountRowData: {
        type: Object,
        require: true,
      },
    },
    data() {
      return {
        tableTotal: 0,
        selectionList: [],
        tableData: [],
        currencyList: [],
        tableRules,
        tableColumnList,
        deleteLineDetailIds: [], //删除明细行的ids
      };
    },

    methods: {
      changeTableRules(val) {
        if (val) {
          this.tableRules.deductionDomesticAmount = [{ required: true, message: '必填字段' }];
        } else {
          this.tableRules.deductionDomesticAmount = [];
          console.log('22222', this.$refs.settleAccountsRef);
          this.$refs.settleAccountsRef.clearActived();
          this.$refs.settleAccountsRef.loadData(this.tableData);
        }
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['originalAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            if (['domesticAmount'].includes(column.property)) {
              return this.sumNum(data, column.property);
            }
            return null;
          }),
        ];
      },
      //是否可以编辑
      activeRowMethod({ columnIndex }) {
        console.log('选中了', columnIndex);
        if (['create'].includes(this.$route.query?.status)) {
          if (this.$route.query?.id) {
            if (columnIndex == 18) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        } else {
          return this.isCreate;
        }
      },
      sumNum(list, field) {
        let count = 0;
        list.forEach((item) => {
          count += +item[field];
        });
        return count > 0 ? count.toFixed(2) : 0;
      },
      //校验
      async validAllEvent() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
          return true;
        } else {
          return false;
        }
      },
      changePageHandler(pageNum, pageSize) {
        console.log(pageNum, pageSize);
      },
      //选择合同移除所有行
      removeRowHandler() {
        let deleteIds = this.getTableData().map((item) => (item.id ? +item.id : null));
        deleteIds = deleteIds.filter((item) => item);
        this.deleteLineDetailIds = this.deleteLineDetailIds.concat(deleteIds);
        this.$emit('saveDeleteLineDetailIds', this.deleteLineDetailIds);
        const $table = this.$refs.settleAccountsRef;
        $table.remove(this.getTableData()); //先删除表格所有数据
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      introductionFeeHandler() {
        const { currencyCode, currencyName, contractNo, exchangeRate } = this.baseFormData;
        const idList = this.tableDataList.map((item) => item.id) || [];
        const { expenseType, spaceAssetName } = this.currentSettleAccountRowData;

        if (!currencyCode || !currencyName || !exchangeRate) {
          this.$message.error('请补充表单数据');
          return;
        }
        console.log('this.contractCategory', this.contractCategory);
        if (
          (this.contractCategory == '01' && (spaceAssetName == null || spaceAssetName == '')) ||
          expenseType == null ||
          expenseType == ''
        ) {
          return this.$message.error('请补充表格信息');
        }
        this.$refs.IntroductionCostDialog.query.contractNo = contractNo;
        this.$refs.IntroductionCostDialog.idList = idList;
        this.$refs.IntroductionCostDialog.query.expenseType = expenseType;
        this.$refs.IntroductionCostDialog.query.spaceAssetNameLike = spaceAssetName;
        this.$refs.IntroductionCostDialog.query.businessCompanyNo = this.userInfo.companyCode;
        this.$refs.IntroductionCostDialog.query.businessDepartmentCode =
          this.userInfo.departmentCode;
        this.$refs.IntroductionCostDialog.openModal();
      },
      confirmHandler(val) {
        this.$emit('importData', val);
      },
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const xIDList = this.selectionList.map((item) => item._XID);
        let deleteIds = this.selectionList.map((item) => (item.id ? +item.id : null));
        deleteIds = deleteIds.filter((item) => item);
        this.deleteLineDetailIds = this.deleteLineDetailIds.concat(deleteIds);
        this.tableData = this.getTableData().filter((item) => !xIDList.includes(item._XID));
        this.$emit('deleteTableHandler', xIDList);
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectionList = selection;
      },
      handleChange(row, field) {
        if (field === 'deductionDomesticAmount') {
          row['deductionOriginalAmount'] = row['deductionDomesticAmount'];
        }
      },
      // 获取币种
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(BASEAPI.LIST_CURRENCY);
        if (selectStatus.data.code == 0) {
          this.currencyList = selectStatus.data.data.map((item) => {
            return {
              value: item.currencyCode,
              label: item.currencyName,
            };
          });
        }
      },
      async closeEditTableHandler() {
        const $table = this.$refs.settleAccountsRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          // this.$message.error('请检查数据再提交');
        } else {
          // 派发事件
          const { currencyCode, currencyName, exchangeRate } = this.baseFormData;
          const tableData = this.getTableData().map((item) => {
            return {
              ...item,
              currencyCode,
              currencyName,
              exchangeRate,
            };
          });
          this.tableData = tableData;
          this.$emit('closeEditTableHandler', tableData);
          await $table.clearActived();
        }
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.settleAccountsRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.tableData = val;
        } else {
          this.tableData = [];
        }
      },
    },
    computed: {
      expenseType() {
        return this.$baseRequest.getDictListMapByType('property_settlement_cost');
      },
      // basic_unit() {
      //   return this.dictListMap.basic_unit;
      // },
    },
    watch: {
      tableDataList: {
        handler(val) {
          console.log(val, '子组件');
          this.fullTableData(val);
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.getCurrencyList();
    },
  };
</script>

<style lang="scss" scoped>
  .settle-accounts-info {
    background: #fff;
    .settle-account-table {
      padding: 10px;
      box-sizing: border-box;
      padding-top: 0;
    }
  }
</style>
